import React from 'react';
import FlexContainer from '@/components/molecules/FlexContainer';
import Icon from '@/components/atoms/UI/Icon/Icon';
import styled from 'styled-components';
import { transition } from '@/styles/template';
import { EXTERNAL_LINKS } from '@/constants/urls';

interface Props {}

const StyledFlexContainer = styled(FlexContainer)`
  & > a {
    transition: ${transition.fastEnd};
  }
  
  & > a:hover {
    opacity: .7;
  }
`;
const NetworksBlock: React.FC<Props> = () => {
	const socialIconSize = 4;

	return (
		<StyledFlexContainer gap='2' centeredContent>
			<a href={EXTERNAL_LINKS.TELEGRAM}><Icon name='Telegram' size={socialIconSize}/></a>
			<a href={EXTERNAL_LINKS.YOUTUBE}><Icon name='YouTube' size={socialIconSize}/></a>
			<a href={EXTERNAL_LINKS.VK}><Icon name='VK' size={socialIconSize}/></a>
		</StyledFlexContainer>

	)
}

export default NetworksBlock